import { makeVar } from '@apollo/client';
/**
 * This represents the current document's type.
 */
export const documentType = makeVar(undefined);
